// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import { Card, Fade, Grid, Icon, InputLabel, Modal, Tooltip } from "@mui/material";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import { gql, useMutation } from "@apollo/client";
import { MessageManager } from "context";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "80%", sm: "70%", xxl: "60%" },
  overflowY: "auto",
  p: 3,
};

export default function ModalNuevoProducto({
  open,
  handleClose,
  listadoProductos,
  setListadoProductos,
  productoElegido,
  guia,
}) {
  const { handleSnackbar } = useContext(MessageManager);

  const [producto, setProducto] = useState();

  useEffect(() => {
    if (!open) {
      setProducto();
    } else {
      if (productoElegido) {
        setProducto(productoElegido);
      }
    }
  }, [open, productoElegido]);

  const handleChangeProducto = (e) => {
    setProducto({
      ...producto,
      [e.target.name]: e.target.value,
    });
  };
  const [saveGuiaDetalle, { loading: loadingSave }] = useMutation(
    gql`
      mutation updateDetalleGuiaTransito($input: GuiaTransitoDetalleInput!) {
        updateDetalleGuiaTransito(input: $input) {
          id
        }
      }
    `
  );
  const handleSave = async () => {
    try {
      const respuesta = await saveGuiaDetalle({
        variables: {
          input: {
            id: productoElegido?.id || null,
            especie: producto.especie,
            cantidad: producto.cantidad,
            descripcion: producto.descripcion,
            idGuia: guia.id,
          },
        },
      });
      handleSnackbar("Guardado correctamente");
      let listadoNuevo = listadoProductos.map((item) => {
        if (item.id === productoElegido?.id) {
          return producto;
        }
        return item;
      });
      if (!productoElegido?.id) {
        listadoNuevo.push({ ...producto, id: respuesta.data.updateDetalleGuiaTransito.id });
      }
      setListadoProductos(listadoNuevo);
    } catch (error) {
      console.error(error);
    } finally {
      handleClose();
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox>
            <SoftBox display="flex" justifyContent="space-between">
              <SoftBox>
                <SoftTypography variant="h6">Nuevo producto</SoftTypography>
              </SoftBox>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftBox>
                  <Tooltip title="Cerrar" placement="top">
                    <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                      close
                    </Icon>
                  </Tooltip>
                </SoftBox>
              </SoftBox>
            </SoftBox>
            <SoftBox py={3}>
              <Grid container spacing={2}>
                <Grid item xs={8} md={10}>
                  <InputLabel htmlFor="especie">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Especie
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    label="especie"
                    placeholder="Ingrese la especie"
                    type="text"
                    name="especie"
                    value={producto?.especie || ""}
                    onChange={handleChangeProducto}
                  />
                </Grid>
                <Grid item xs={4} md={2}>
                  <InputLabel htmlFor="cantidad">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Cantidad
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    label="cantidad"
                    type="number"
                    name="cantidad"
                    value={producto?.cantidad || ""}
                    onChange={handleChangeProducto}
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="descripcion">
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                      Descripción
                    </SoftTypography>
                  </InputLabel>
                  <SoftInput
                    label="descripcion"
                    placeholder="Ingrese la descripcion"
                    type="text"
                    name="descripcion"
                    value={producto?.descripcion || ""}
                    onChange={handleChangeProducto}
                  />
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox
              display={{
                xs: "flex-row",
                sm: "flex",
              }}
              justifyContent="flex-end"
              alignItems="center"
            >
              <SoftBox
                display={{
                  xs: "flex-row",
                  sm: "flex",
                }}
                justifyContent="end"
                alignItems="center"
              >
                <SoftBox
                  mr={{
                    xs: 0,
                    sm: 2,
                  }}
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="primary"
                    onClick={handleClose}
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                  >
                    <Icon sx={{ fontWeight: "light" }}>cancel</Icon>
                    &nbsp;Cancelar
                  </SoftButton>
                </SoftBox>
                <SoftBox
                  mt={{
                    xs: 2,
                    sm: 0,
                  }}
                >
                  <SoftButton
                    color="gobSecondary"
                    onClick={handleSave}
                    fullWidth={{
                      xs: true,
                      sm: false,
                    }}
                    disabled={
                      !producto?.especie ||
                      !producto?.cantidad ||
                      !producto?.descripcion ||
                      loadingSave
                    }
                  >
                    <Icon sx={{ fontWeight: "light" }}>save</Icon>
                    &nbsp;Guardar
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalNuevoProducto.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  listadoProductos: PropTypes.array,
  setListadoProductos: PropTypes.func,
  productoElegido: PropTypes.object,
  guia: PropTypes.object,
};
